export const PIMSTER_STATIC_CDN = 'https://cdn.pimster.app';
